import Home from "./views/Home";

function App() {
  return (
    <Home></Home>
  );
}

export default App;
